import React from "react";

export default function Footer() {
  return (
    <div className="footer-box">
      <p>
        Copyright (c) 2024 GTM. All rights reserved. Designed and Managed by PCI
        India
      </p>
    </div>
  );
}
